"use client";
import {Button} from "@/components/ui/button";
import {User} from "lucide-react";
import React, {useEffect} from "react";
import {useRouter} from "next/navigation";
import Link from "next/link";
import {sendGTMEvent} from "@next/third-parties/google";
import {useAuthStore} from "@/store/auth/authStore";

function UserButtonComponent() {
    const router = useRouter();
    const {user , token , setUser} = useAuthStore((state) => state);

    useEffect(() => {
        if (!token) {
            setUser(undefined)
        }
    }, [token]);

    return (
        <>
            {token ? (
                <div
                    title={`${user?.first_name} ${user?.last_name}`}
                    className="border w-[96px] h-[44px] gap-1 bg-[#EBEBEB] rounded-full p-1 flex items-center"
                >
                    <Link
                        data-tag-manager="btn-profile-desktop"
                        onClick={() => sendGTMEvent({ event: 'buttonClicked', value: 'btn-profile-desktop' })}
                        aria-label="profile"
                        href={"/profile"}
                        className="px-2 flex items-center justify-center hover:bg-gray-50 bg-white rounded-full w-[34px] h-[34px]"
                    >
                        <User/>
                    </Link>
                    <span className={"font-medium text-xs text-nowrap truncate"}>
            {user?.first_name} {" "} {user?.last_name}
          </span>
                </div>
            ) : (
                <Button
                    data-tag-manager="btn-profile-desktop"
                    aria-label="profile"
                    onClick={() => {
                        router.push("/auth");
                        sendGTMEvent({ event: 'buttonClicked', value: 'btn-profile-desktop' })
                    }}
                    variant={"none"}
                    className="px-2 bg-white rounded-full group"
                >
                    <User className={"group-hover:stroke-gray-500 duration-100"}/>
                </Button>
            )}
        </>
    );
}

export default React.memo(UserButtonComponent);
